<template>
  <vx-card class="Payslip-Reports">
    <div class="payslip-mode-toggle">
      <vs-button
        :type="activeMode === 'single' ? 'filled' : 'border'"
        color="primary"
        @click="activeMode = 'single'"
        >Single Download</vs-button
      >
      <vs-button
        :type="activeMode === 'bulk' ? 'filled' : 'border'"
        color="primary"
        @click="activeMode = 'bulk'"
        >Bulk Download</vs-button
      >
    </div>

    <div v-show="activeMode === 'single'">
      <div class="vx-col md:w-1/2 w-full mt-5">
        <span class="text-sm">Users</span><span style="color: red">*</span>
        <v-select
          v-validate="'required'"
          class="w-full"
          name="Users"
          v-model="selectedUser"
          label="fullName"
          :options="getusers"
          placeholder="Please Select"
          @input="handleUserSelection"
        />
        <span class="text-danger">{{ errors.first("Users") }}</span>
      </div>

      <div>
        <div
          class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
        >
          <div class="vx-col sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-1/5 w-full mb-2">
            <span class="text-sm">Payout Date </span
            ><span style="color: red">*</span>
            <v-select
              class="mb-3"
              v-model="payOutDate"
              name="payOutDate-name"
              :options="payOutDateList"
            />
            <vs-button
              class="download-Payslip"
              type="gradient"
              color="primary"
              @click="downloadPayslip()"
              icon-pack="feather"
              icon="icon-download"
              :disabled="this.payOutDate == null"
              >Download</vs-button
            >
          </div>
        </div>
      </div>
      <div>
        <div class="vx-col flex-1" id="account-info-col-2">
          <div
            id="div-with-loading"
            class="scroll-content ex1 vs-con-loading__container"
          >
            <input
              class="mb-3"
              v-show="payOutDate != null"
              v-model.number="page"
              type="number"
              style="
                width: 3em;
                padding: 0.3rem;
                font-size: 1rem;
                border: 1px solid rgba(0, 0, 0, 0.2);
              "
            />
            <span class="text-sm" style="color: white"> / {{ numPages }}</span>
            <div
              v-if="loadedRatio > 0 && loadedRatio < 1"
              style="background-color: green; color: white; text-align: center"
              :style="{ width: loadedRatio * 100 + '%' }"
            >
              {{ Math.floor(loadedRatio * 100) }}%
            </div>
            <pdf
              class="overflow-hidden"
              ref="pdf"
              style="display: inline-block; width: 100%"
              :src="linkURL"
              :page="page"
              @password="password"
              @error="error"
              @num-pages="numPages = $event"
              @link-clicked="page = $event"
            >
            </pdf>
          </div>
        </div>
      </div>
    </div>

    <div v-show="activeMode === 'bulk'" class="bulk-payslip-section">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <span class="text-sm">Payout Date</span><span style="color: red">*</span>
          <v-select
            class="w-full bulk-payout-date-select"
            v-model="bulkPayOutDate"
            :options="bulkPayOutDateList"
            :disabled="isBulkDateLoading || isBulkDownloading"
            placeholder="Select Payout Date"
          />
          <span v-if="isBulkDateLoading" class="text-sm bulk-date-loading">
            Loading payslips...
          </span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <span class="text-sm">Employees</span><span style="color: red">*</span>
          <div class="bulk-select-tools">
            <span class="text-sm bulk-headcount">
              {{ bulkUsers.length }} of {{ bulkUserOptions.length }}
              {{ bulkUserOptions.length === 1 ? "employee" : "employees" }}
              selected
            </span>
            <div class="bulk-select-buttons">
              <vs-button
                size="small"
                type="border"
                color="primary"
                :disabled="
                  bulkUserOptions.length === 0 ||
                  bulkPayOutDate === null ||
                  isBulkDownloading
                "
                @click="selectAllBulkUsers"
                >Select All</vs-button
              >
              <vs-button
                size="small"
                type="border"
                color="danger"
                :disabled="bulkUsers.length === 0 || isBulkDownloading"
                @click="clearBulkUsers"
                >Clear</vs-button
              >
            </div>
          </div>
          <v-select
            class="w-full"
            v-model="bulkUsers"
            label="fullName"
            :options="bulkUserOptions"
            multiple
            :disabled="bulkPayOutDate === null || isBulkDownloading"
            :placeholder="
              bulkPayOutDate === null
                ? 'Select a payout date first'
                : 'Select Employees'
            "
          />
        </div>
      </div>
      <div class="bulk-actions">
        <vs-button
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-download"
          :disabled="!canBulkDownload"
          @click="bulkDownloadPayslips"
          >Bulk Download</vs-button
        >
      </div>
      <div v-if="isBulkDownloading || bulkDownloadProgress.total > 0" class="bulk-status">
        <span class="text-sm">{{ bulkProgressText }}</span>
        <div class="bulk-progress-bar">
          <div
            class="bulk-progress-fill"
            :style="{ width: bulkProgressPercent + '%' }"
          />
        </div>
      </div>
      <div v-if="bulkDownloadFailures.length > 0" class="bulk-failures">
        <span class="text-sm">Failed Downloads</span>
        <ul>
          <li v-for="failure in bulkDownloadFailures" :key="failure.id">
            {{ failure.name }} - {{ failure.reason }}
          </li>
        </ul>
      </div>
    </div>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import axios from "@/axios.js";
import Swal from "sweetalert2";
import pdf from "vue-pdf";

export default {
  data() {
    return {
      page: 1,
      numPages: 0,
      selectedUser: null,
      id: null,
      fullName: "",
      loadedRatio: 0,
      payOutDateList: [],
      payOutDate: null,
      linkURL: "",
      p: "Dela Cruz2007-004",
      activeMode: "single",
      bulkUsers: [],
      bulkPayOutDate: null,
      bulkPayOutDateList: [],
      bulkEmployeesByPayOutDate: {},
      bulkEmployeeListKey: "",
      isBulkDateLoading: false,
      bulkDateRequestId: 0,
      bulkPayOutDateFailures: [],
      isBulkDownloading: false,
      bulkDownloadProgress: {
        completed: 0,
        total: 0,
      },
      bulkDownloadFailures: [],
      bulkDownloadSuccessCount: 0,
      bulkDownloadConcurrency: 3,
    };
  },
  components: {
    pdf,
    "v-select": vSelect,
  },
  computed: {
    getusers() {
      return this.$store.state.hrms.allEmployee;
    },
    bulkUserOptions() {
      if (this.bulkPayOutDate === null) return [];

      const eligibleIds =
        this.bulkEmployeesByPayOutDate[this.bulkPayOutDate] || [];
      return this.getusers.filter((user) => eligibleIds.includes(user.id));
    },
    convertPayOutDate() {
      return (d) => {
        var dt = moment(d, "YYYYMMDD");
        return dt.format("DD-MMM-YYYY");
      };
    },
    canBulkDownload() {
      return (
        this.bulkUsers.length > 0 &&
        this.bulkPayOutDate !== null &&
        !this.isBulkDateLoading &&
        !this.isBulkDownloading
      );
    },
    bulkProgressPercent() {
      if (this.bulkDownloadProgress.total === 0) return 0;
      return Math.floor(
        (this.bulkDownloadProgress.completed /
          this.bulkDownloadProgress.total) *
          100
      );
    },
    bulkProgressText() {
      if (this.bulkDownloadProgress.total === 0) return "";
      return `Downloaded ${this.bulkDownloadProgress.completed} of ${this.bulkDownloadProgress.total} payslips`;
    },
  },
  watch: {
    selectedUser() {
      // Call the method to format the user ID

      this.UserId();
    },

    payOutDate() {
      this.linkURL = null;
      this.loadingTask();
    },
    page() {
      if (this.page <= 0) this.page = 1;
      else if (this.page > this.numPages) this.page = this.numPages;
    },
    bulkUsers() {
      this.bulkDownloadFailures = [];
    },
    bulkPayOutDate() {
      this.bulkUsers = [];
      this.bulkDownloadFailures = [];
      this.bulkDownloadProgress = {
        completed: 0,
        total: 0,
      };
    },
    activeMode(mode) {
      if (mode === "bulk") this.getBulkPayslipList();
    },
    getusers(users) {
      if (
        this.activeMode === "bulk" &&
        users.length > 0 &&
        this.bulkPayOutDateList.length === 0 &&
        !this.isBulkDateLoading
      ) {
        this.getBulkPayslipList();
      }
    },
  },
  methods: {
    UserId() {
      // Check if selectedUser and userId exist
      if (this.selectedUser && this.selectedUser.id) {
        // Assign the raw user ID to the formattedUserId
        this.uid = this.selectedUser.id;

        // Reset payOutDate when a user is selected
        this.payOutDate = null;
      } else {
        this.uid = null; // Handle the case where there is no selected user or user ID
      }
    },
    handleUserSelection() {
      if (this.selectedUser && this.selectedUser.id) {
        this.uid = this.selectedUser.id;
        this.getPaylipList(); // Call getPaylipList when user is selected
      } else {
        this.uid = null;
      }
    },
    getPaylipList() {
      this.payOutDateList = [];
      this.$vs.loading();

      try {
        if (!this.selectedUser) {
          throw new Error("selectedUser is null or undefined.");
        }

        if (
          this.selectedUser.id === undefined ||
          this.selectedUser.id === null
        ) {
          throw new Error("selectedUser does not have an id property.");
        }

        const userId = String(this.selectedUser.id);

        this.$store
          .dispatch("getPayslipList", userId)
          .then((response) => {
            let p = response.data;
            p.forEach((payOutDate) => {
              this.payOutDateList.push(
                this.convertPayOutDate(payOutDate.substr(payOutDate.length - 8))
              );
            });
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$alert(error.message, "Error loading payslip dates", "error");
          });
      } catch (error) {
        this.$vs.loading.close();
        this.$alert(error.message, "Error loading payslip dates", "error");
      }
    },

    loadingTask() {
      this.linkURL = null;
      if (this.payOutDate != null) {
        const data = {
          userId: this.selectedUser ? this.selectedUser.id : null,
          payOutDate: moment(this.payOutDate).format("YYYYMMDD"),
        };
        this.$store
          .dispatch("getViewPayslip", data)
          .then((response) => {
            this.linkURL = response.request.responseURL;
          })
          .catch((error) => {
            this.linkURL = null;
            this.$alert(error, "Error", "error");
          });
      }
    },
    // password: function (updatePassword, reason) {
    //   Swal.fire({
    //     title: "Enter your password",
    //     input: "password",
    //     inputLabel: "Password",
    //     inputPlaceholder: "Max of 10 characters",
    //     inputAttributes: {
    //       maxlength: 50,
    //       autocapitalize: "off",
    //       autocorrect: "off",
    //       showCancelButton: true,
    //     },
    //   })
    //     .then((t) => {
    //       if (t.isConfirmed) {
    //         updatePassword(t.value);
    //         if (t.value == "") return;
    //         this.$vs.loading({
    //           container: "#div-with-loading",
    //           scale: 0.6,
    //         });
    //         setTimeout(() => {
    //           this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    //         }, 2000);
    //       } else {
    //         Swal.fire("View Payslip", "Cancelled", "warning");
    //         this.$router.go();
    //       }
    //     })
    //     .catch(() => {
    //       Swal.fire("Payslip not loaded", "Cancelled", "warning");
    //     });
    // },
password(updatePassword) {
  if (this.selectedUser && this.selectedUser.lastName && this.selectedUser.employeeCode) {
   const password = `${this.selectedUser.lastName}${this.selectedUser.employeeCode}`.replace(/\s/g, '').toLowerCase();
    updatePassword(password);
    this.$vs.loading({
      container: "#div-with-loading",
      scale: 0.6,
    });
    setTimeout(() => {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    }, 2000);
  } else {
    // Fallback if selectedUser is missing data
    this.$alert("Missing user information to construct password", "Error", "error");
    this.$router.go();
  }
},
    error: function (err) {
      this.$alert(err, "Error", "error");
    },
    selectAllBulkUsers() {
      this.bulkUsers = this.bulkUserOptions.slice();
    },
    clearBulkUsers() {
      this.bulkUsers = [];
    },
    getFormattedPayslipDates(responseData) {
      return responseData.map((payOutDate) =>
        this.convertPayOutDate(payOutDate.substr(payOutDate.length - 8))
      );
    },
    getBulkPayslipList() {
      const employeeListKey = this.getusers
        .map((employee) => employee.id)
        .sort()
        .join(",");

      if (
        employeeListKey === this.bulkEmployeeListKey &&
        this.bulkPayOutDateList.length > 0
      ) {
        return;
      }

      const requestId = this.bulkDateRequestId + 1;
      this.bulkDateRequestId = requestId;
      this.bulkPayOutDateList = [];
      this.bulkEmployeesByPayOutDate = {};
      this.bulkPayOutDateFailures = [];
      this.bulkPayOutDate = null;
      this.bulkUsers = [];

      if (this.getusers.length === 0) return;

      this.isBulkDateLoading = true;
      this.showBulkPayOutDateLoading();

      Promise.all(
        this.getusers.map((employee) =>
          this.$store
            .dispatch("getPayslipList", String(employee.id))
            .then((response) => ({
              employeeId: employee.id,
              dates: this.getFormattedPayslipDates(response.data),
              failed: false,
            }))
            .catch((error) => ({
              dates: [],
              failed: true,
              failure: {
                id: employee.id,
                name: employee.employeeCode || employee.fullName || employee.id,
                reason: this.getBulkDownloadErrorMessage(error),
              },
            }))
        )
      )
        .then((results) => {
          if (requestId !== this.bulkDateRequestId) return;
          this.bulkPayOutDateFailures = results
            .filter((result) => result.failed)
            .map((result) => result.failure);

          const employeesByDate = {};
          results
            .filter((result) => !result.failed)
            .forEach((result) => {
              result.dates.forEach((date) => {
                if (!employeesByDate[date]) employeesByDate[date] = [];
                employeesByDate[date].push(result.employeeId);
              });
            });

          this.bulkEmployeesByPayOutDate = employeesByDate;
          this.bulkEmployeeListKey = employeeListKey;
          this.bulkPayOutDateList = Object.keys(employeesByDate).sort(
            (a, b) => moment(b, "DD-MMM-YYYY").diff(moment(a, "DD-MMM-YYYY"))
          );
          this.closeBulkPayOutDateLoading();
        })
        .catch((error) => {
          if (requestId !== this.bulkDateRequestId) return;
          this.bulkPayOutDateList = [];
          this.bulkEmployeesByPayOutDate = {};
          this.closeBulkPayOutDateLoading();
          this.$alert(error.message, "Unable to load bulk payslip dates", "error");
        })
        .finally(() => {
          if (requestId !== this.bulkDateRequestId) return;
          this.isBulkDateLoading = false;
        });
    },
    sanitizeFileName(value) {
      return String(value || "Payslip")
        .replace(/[\\/:*?"<>|]/g, "")
        .replace(/\s+/g, "_");
    },
    getContentDispositionFileName(contentDisposition) {
      if (!contentDisposition) return null;
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      return match ? match[1].replace(/"/g, "") : null;
    },
    getPayslipFileName(employee) {
      return `${this.sanitizeFileName(employee.employeeCode || employee.id)}.pdf`;
    },
    getBulkDownloadErrorMessage(error) {
      if (error.response) {
        const statusText = error.response.statusText
          ? ` ${error.response.statusText}`
          : "";
        return `Request failed (${error.response.status}${statusText})`;
      }

      if (error.request) {
        return "No response received from server";
      }

      return error.message || "Unable to download";
    },
    showBulkPayOutDateLoading() {
      Swal.fire({
        title: "Loading Payslips",
        html: "Please wait while available payslips are checked.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },
    closeBulkPayOutDateLoading() {
      if (
        Swal.isVisible() &&
        Swal.getTitle() &&
        Swal.getTitle().textContent === "Loading Payslips"
      ) {
        Swal.close();
      }
    },
    triggerBlobDownload(blob, fileName) {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    },
    async downloadPayslipForEmployee(employee, payOutDate) {
      const response = await axios.get("/api/reports/payslip", {
        params: {
          userId: employee.id,
          payOutDate: payOutDate,
        },
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
      });

      const fileName = this.getPayslipFileName(employee);

      this.triggerBlobDownload(new Blob([response.data]), fileName);
    },
    async runBulkPayslipQueue(employees, payOutDate) {
      let nextIndex = 0;
      const workers = Array.from(
        {
          length: Math.min(this.bulkDownloadConcurrency, employees.length),
        },
        async () => {
          while (nextIndex < employees.length) {
            const currentIndex = nextIndex;
            const employee = employees[currentIndex];
            nextIndex += 1;

            try {
              await this.downloadPayslipForEmployee(
                employee,
                payOutDate
              );
              this.bulkDownloadSuccessCount += 1;
              await new Promise((resolve) => setTimeout(resolve, 300));
            } catch (error) {
              this.bulkDownloadFailures.push({
                id: employee.id,
                name: employee.employeeCode || employee.fullName || employee.id,
                reason: this.getBulkDownloadErrorMessage(error),
              });
            } finally {
              this.bulkDownloadProgress.completed += 1;
            }
          }
        }
      );

      await Promise.all(workers);
    },
    async bulkDownloadPayslips() {
      if (!this.canBulkDownload) return;

      const payOutDate = moment(this.bulkPayOutDate).format("YYYYMMDD");
      const employees = this.bulkUsers.slice();

      this.isBulkDownloading = true;
      this.bulkDownloadFailures = [];
      this.bulkDownloadSuccessCount = 0;
      this.bulkDownloadProgress = {
        completed: 0,
        total: employees.length,
      };

      this.$vs.loading();

      try {
        await this.runBulkPayslipQueue(employees, payOutDate);
        this.$vs.loading.close();

        if (this.bulkDownloadFailures.length > 0) {
          const failedItems = this.bulkDownloadFailures
            .map((failure) => `${failure.name}: ${failure.reason}`)
            .join("<br>");

          Swal.fire({
            title: "Bulk Download Error",
            html: `${this.bulkDownloadSuccessCount} payslips downloaded.<br>${this.bulkDownloadFailures.length} failed.<br><br>${failedItems}`,
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Done",
            html: "Payslips downloaded",
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        this.$vs.loading.close();
        Swal.fire({
          title: "Bulk Download Error",
          html: this.getBulkDownloadErrorMessage(error),
          icon: "error",
        });
      } finally {
        this.isBulkDownloading = false;
      }
    },
    

    downloadPayslip() {
      this.$vs.loading();

      axios
        .get(this.linkURL, {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        })
        .then((response) => {
          this.$vs.loading.close();

          // Check if the response has content-disposition header
          const contentDisposition = response.headers["content-disposition"];
          if (!contentDisposition) {
            this.$alert("The downloaded file did not include a filename.", "Download Error", "error");
            return;
          }

          // Extract the filename from the content-disposition header
          const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);

          // Extract user ID and payout date
          const userId = this.selectedUser
            ? this.selectedUser.id
            : "unknownUserId";
          const payoutDate = this.payOutDate
            ? moment(this.payOutDate).format("YYYYMMDD")
            : "unknownPayoutDate";

          // Construct the filename
          const fileName = fileNameMatch
            ? fileNameMatch[1]
            : `${userId}_${payoutDate}.pdf`;

          // Create a Blob from the response data
          const blob = new Blob([response.data]);

          // Create a download link
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;

          // Trigger the download
          link.click();

          // Clean up
          window.URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error.message, "Error downloading payslip", "error");
        });
    },
  },
};
</script>

<style>
div.ex1 {
  background-color: #888888;
  width: 100%;
  overflow: auto;
  border: 1px solid;
  padding: 10px;
  border-radius: 5px 0px 0px 5px;
}

.Payslip-Reports {
  text-align: center;
}

.Payslip-Reports .vx-col {
  width: 100%;
  margin: 0 auto; /* Center the column horizontally */
}

.Payslip-Reports .vx-row {
  width: 100%;
}
.download-Payslip {
  display: flex;
  margin: 0 auto;
}
.payslip-mode-toggle {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.bulk-payslip-section {
  text-align: left;
}

.bulk-select-tools {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.bulk-headcount {
  color: #626262;
}

.bulk-select-buttons {
  display: flex;
  gap: 8px;
}

.bulk-date-loading {
  display: inline-block;
  margin-top: 8px;
}

.bulk-payout-date-select .vs__dropdown-menu {
  max-height: 240px;
  overflow-y: auto;
}

.bulk-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.bulk-status {
  max-width: 520px;
  margin: 20px auto 0;
  text-align: center;
}

.bulk-progress-bar {
  height: 8px;
  width: 100%;
  overflow: hidden;
  background: #e5e7eb;
  border-radius: 4px;
  margin-top: 8px;
}

.bulk-progress-fill {
  height: 100%;
  background: #28c76f;
  transition: width 0.2s ease;
}

.bulk-failures {
  max-width: 720px;
  margin: 20px auto 0;
  color: #ea5455;
}
.vs__dropdown-menu {
  max-height: 200px;
}

.Payout-Date-Vselect {
  width: 20%;
  padding-right: 20px;
}

@media (max-width: 630px) {
  .Payout-Date-Vselect {
    width: 70%;
  }
}
</style>
